<template>
  <div>
    <b-card>
      <b-card-header>
        <h2>
          <feather-icon icon="LayersIcon" />
          {{  $t('Routes.editModel')  }}
        </h2>
      </b-card-header>
      <b-card-body>
        <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
          <b-form @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">
            <b-row>
              <b-col cols="12">
                <validation-provider #default="{ errors }" :name="$t('AppTI.model.name')" rules="required">
                  <b-form-group :label="$t('AppTI.model.name')" label-for="type">
                    <b-form-input type="text" placeholder="ThinkPad-T5" v-model="modelData.nombre" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{  errors[0]  }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12">
                <validation-provider #default="{ errors }" :name="$t('AppTI.model.description')"
                  rules="required|max:1025">
                  <b-form-group :label="$t('AppTI.model.description')" label-for="description">
                    <b-form-textarea id="description" v-model="modelData.descripcion" rows="3"
                      placeholder="Laptop tipo tablet" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{  errors[0]  }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="6">
                <validation-provider #default="{ errors }" :name="$t('AppTI.model.brand')" rules="required">
                  <b-form-group :label="$t('AppTI.model.brand')">
                    <v-select id="marcas" v-model="modelData.tipoMarcaId"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="texto" :options="brands"
                      :reduce="option => option.id" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{  errors[0]  }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="6">
                <validation-provider #default="{ errors }" :name="$t('AppTI.model.type')" rules="required">
                  <b-form-group :label="$t('AppTI.model.type')">
                    <v-select id="marcas" v-model="modelData.tipoEquipoId"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="texto" :options="typeEquipments"
                      :reduce="option => option.id" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{  errors[0]  }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row class="float-right mt-2 mb-2">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit">
                <b-spinner v-if="addingBrand" small class="mr-1" />
                {{  $t('Lists.Edit')  }}
              </b-button>
            </b-row>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
  BSpinner,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormGroup,
  BFormInvalidFeedback,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  required, max,
} from '@validations'
import tiService from '@/services/informationTecnology.service'
import formValidation from '@core/comp-functions/forms/form-validation'
import { ref } from '@vue/composition-api'
import router from '@/router'
import vSelect from 'vue-select'
import optionService from '@/services/option.service'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BSpinner,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormGroup,
    BFormInvalidFeedback,

    ValidationObserver,
    ValidationProvider,

    vSelect,

  },
  data() {
    return {
      required,
      max,
    }
  },
  setup() {
    const modelData = ref({
      tipoEquipoMarcaModeloId: 0,
      tipoMarcaId: 0,
      tipoEquipoId: 0,
      nombre: '',
      descripcion: '',
      archivado: false,
    })

    const modelBlank = {
      tipoEquipoMarcaModeloId: 0,
      tipoMarcaId: 0,
      tipoEquipoId: 0,
      nombre: '',
      descripcion: '',
      archivado: false,
    }

    const resetModelData = () => {
      modelData.value = JSON.parse(JSON.stringify(modelBlank))
    }

    const addingModel = ref(false)
    const brands = ref([])
    const typeEquipments = ref([])
    const {
      updateModel,
      fetchModel,
    } = tiService()
    const { fetchOptions } = optionService()

    fetchOptions({ nombreDominio: 'tipoMarca' }, data => {
      brands.value = data
    })

    fetchOptions({ nombreDominio: 'tipoEquipo' }, data => {
      typeEquipments.value = data
    })

    fetchModel(router.currentRoute.params.tipoEquipoMarcaModeloId, data => {
      modelData.value = data
    })

    const {
      refFormObserver,
      resetForm,
      getValidationState,
    } = formValidation(resetModelData)

    const onSubmit = () => {
      addingModel.value = true
      updateModel(modelData.value)
        .then(() => {
          addingModel.value = false
          router.push({ name: 'apps-model-list' })
        })
    }
    return {
      refFormObserver,
      resetForm,
      getValidationState,
      modelData,
      addingModel,
      typeEquipments,
      brands,
      onSubmit,
    }
  },
}
</script>
